import { Dispatch, SetStateAction } from 'react';

import { SelectChartsXAxisLabel } from '@/components/SessionsTable/components/SelectChartsXAxisLabel';

import { DatasetSessionCompareBarChartSpec } from '../constants';
import { SummaryChartsDropdown } from './SummaryChartsDropdown';

export const ChartsHeader = ({
  barChartSpecs,
  selectedCharts,
  setSelectedCharts,
  aggregateMetadataKeys,
  experimentMetadataPath,
  setExperimentMetadataPath,
}: {
  barChartSpecs: DatasetSessionCompareBarChartSpec[];
  selectedCharts: DatasetSessionCompareBarChartSpec[];
  setSelectedCharts: Dispatch<
    SetStateAction<DatasetSessionCompareBarChartSpec[]>
  >;
  aggregateMetadataKeys: string[];
  experimentMetadataPath: string | undefined;
  setExperimentMetadataPath: (path: string | undefined) => void;
}) => {
  return (
    <div className="mb-2 flex gap-2">
      <SummaryChartsDropdown
        barChartSpecs={barChartSpecs}
        selectedCharts={selectedCharts}
        setSelectedCharts={setSelectedCharts}
      />

      <SelectChartsXAxisLabel
        aggregateMetadataKeys={aggregateMetadataKeys}
        experimentMetadataPath={experimentMetadataPath}
        setExperimentMetadataPath={setExperimentMetadataPath}
      />
    </div>
  );
};
